export default __webpack_public_path__ + "static/card-setup-pix-4db8bf3a4f7ba95afe4fb1d146dd9e62.png";